// extracted by mini-css-extract-plugin
module.exports = {"quickShopLink":"DA-z","button":"EA-z","disabled":"FA-z"};